/* eslint-disable camelcase */
import { FC } from 'react';

import { MutToTez } from '@utils/format';
import { Box, Text, Tooltip } from '@versumstudios/ui';

interface ISwapTypeComponent {
  start_price: number;
  end_price: number;
  ending_time?: number;
}

export const SwapTypeComponent: FC<ISwapTypeComponent> = ({ start_price, end_price, ending_time }) => {
  if (ending_time) {
    return (
      <Box css={{ flexDirection: 'column' }}>
        <Text unset css={{ fontSize: 11, color: '$secondaryFill' }}>
          Time-limited&nbsp;
          <Tooltip description="Time-limited swaps automatically end at set date.">
            <i>help</i>
          </Tooltip>
        </Text>
      </Box>
    );
  }

  if (start_price === end_price) {
    return (
      <Box css={{ flexDirection: 'column' }}>
        <Text unset css={{ fontSize: 11, color: '$secondaryFill' }}>
          Simple Swap&nbsp;
          <Tooltip description="Simple swaps have a fixed price">
            <i>help</i>
          </Tooltip>
        </Text>
      </Box>
    );
  }

  return (
    <Box css={{ flexDirection: 'column' }}>
      <Text unset css={{ fontSize: 11, color: '$secondaryFill' }}>
        Advanced Swap&nbsp;
        <Tooltip
          description={`Advanced swaps have a dynamic price based of a start price and an end price. Start price: ${MutToTez(
            start_price
          )}, End price:  ${MutToTez(end_price)}.`}
        >
          <i>help</i>
        </Tooltip>
      </Text>
    </Box>
  );
};
